module.exports = __webpack_public_path__ + "assets/img/Audi_S3_Banner_Mobile_20210223_V5.d55dc1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/picture/Audi_S3_Banner_Mobile_20210223_V5.jpg
// module id = FBZd
// module chunks = 1